import { render } from "./UnauthorizedState.vue?vue&type=template&id=ab274d3c"
import script from "./UnauthorizedState.vue?vue&type=script&lang=js"
export * from "./UnauthorizedState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__